export const getTmpId = (tmpArray: any[] | undefined = undefined) => {
    let tmpId = -1;

    if (tmpArray !== undefined && tmpArray.length > 0) {
        let tmpIdArray = Math.min(...tmpArray.map((x) => x["id"])) - 1;

        if (tmpIdArray <= tmpId) {
            tmpId = tmpIdArray - 1;
        }
    }

    return tmpId;
};

export const insertIntoArray = (currentObject: any, currentArray: any[]) => {
    let tmpObject = currentArray.find((x) => x.id === currentObject.id);
    let tmpArray = [...currentArray];

    if (tmpObject === undefined) {
        tmpArray = [...tmpArray, currentObject];
    } else {
        tmpArray = tmpArray.map((x) => (x.id === currentObject.id ? currentObject : x));
    }
    return tmpArray;
};
